export const SPACING_UTILS = {
  spacing: (value: string) => ({
    padding: value,
  }),
  spacingHorizontal: (value: string) => ({
    paddingLeft: value,
    paddingRight: value,
  }),
  spacingVertical: (value: string) => ({
    paddingTop: value,
    paddingBottom: value,
  }),
  spacingTop: (value: string) => ({
    paddingTop: value,
  }),
  spacingRight: (value: string) => ({
    paddingRight: value,
  }),
  spacingBottom: (value: string) => ({
    paddingBottom: value,
  }),
  spacingLeft: (value: string) => ({
    paddingLeft: value,
  }),
};

export const SPACING_VARIANTS = {
  spacing: {
    [0]: {
      spacing: "0",
    },
    [1]: {
      spacing: "$space$1",
    },
    [2]: {
      spacing: "$space$2",
    },
    [3]: {
      spacing: "$space$3",
    },
    [4]: {
      spacing: "$space$4",
    },
    [5]: {
      spacing: "$space$5",
    },
    [6]: {
      spacing: "$space$6",
    },
    [7]: {
      spacing: "$space$7",
    },
    [8]: {
      spacing: "$space$8",
    },
    [9]: {
      spacing: "$space$9",
    },
    [10]: {
      spacing: "$space$10",
    },
    [11]: {
      spacing: "$space$11",
    },
    [12]: {
      spacing: "$space$12",
    },
  },
  spacingHorizontal: {
    [0]: {
      spacingHorizontal: "0",
    },
    [1]: {
      spacingHorizontal: "$space$1",
    },
    [2]: {
      spacingHorizontal: "$space$2",
    },
    [3]: {
      spacingHorizontal: "$space$3",
    },
    [4]: {
      spacingHorizontal: "$space$4",
    },
    [5]: {
      spacingHorizontal: "$space$5",
    },
    [6]: {
      spacingHorizontal: "$space$6",
    },
    [7]: {
      spacingHorizontal: "$space$7",
    },
    [8]: {
      spacingHorizontal: "$space$8",
    },
    [9]: {
      spacingHorizontal: "$space$9",
    },
    [10]: {
      spacingHorizontal: "$space$10",
    },
    [11]: {
      spacingHorizontal: "$space$11",
    },
    [12]: {
      spacingHorizontal: "$space$12",
    },
  },
  spacingVertical: {
    [0]: {
      spacingVertical: "0",
    },
    [1]: {
      spacingVertical: "$space$1",
    },
    [2]: {
      spacingVertical: "$space$2",
    },
    [3]: {
      spacingVertical: "$space$3",
    },
    [4]: {
      spacingVertical: "$space$4",
    },
    [5]: {
      spacingVertical: "$space$5",
    },
    [6]: {
      spacingVertical: "$space$6",
    },
    [7]: {
      spacingVertical: "$space$7",
    },
    [8]: {
      spacingVertical: "$space$8",
    },
    [9]: {
      spacingVertical: "$space$9",
    },
    [10]: {
      spacingVertical: "$space$10",
    },
    [11]: {
      spacingVertical: "$space$11",
    },
    [12]: {
      spacingVertical: "$space$12",
    },
  },
  spacingTop: {
    [0]: {
      spacingTop: "0",
    },
    [1]: {
      spacingTop: "$space$1",
    },
    [2]: {
      spacingTop: "$space$2",
    },
    [3]: {
      spacingTop: "$space$3",
    },
    [4]: {
      spacingTop: "$space$4",
    },
    [5]: {
      spacingTop: "$space$5",
    },
    [6]: {
      spacingTop: "$space$6",
    },
    [7]: {
      spacingTop: "$space$7",
    },
    [8]: {
      spacingTop: "$space$8",
    },
    [9]: {
      spacingTop: "$space$9",
    },
    [10]: {
      spacingTop: "$space$10",
    },
    [11]: {
      spacingTop: "$space$11",
    },
    [12]: {
      spacingTop: "$space$12",
    },
  },

  spacingRight: {
    [0]: {
      spacingBottom: "0",
    },
    [1]: {
      spacingRight: "$space$1",
    },
    [2]: {
      spacingRight: "$space$2",
    },
    [3]: {
      spacingRight: "$space$3",
    },
    [4]: {
      spacingRight: "$space$4",
    },
    [5]: {
      spacingRight: "$space$5",
    },
    [6]: {
      spacingRight: "$space$6",
    },
    [7]: {
      spacingRight: "$space$7",
    },
    [8]: {
      spacingRight: "$space$8",
    },
    [9]: {
      spacingRight: "$space$9",
    },
    [10]: {
      spacingRight: "$space$10",
    },
    [11]: {
      spacingRight: "$space$11",
    },
    [12]: {
      spacingRight: "$space$12",
    },
  },
  spacingBottom: {
    [0]: {
      spacingBottom: "0",
    },
    [1]: {
      spacingBottom: "$space$1",
    },
    [2]: {
      spacingBottom: "$space$2",
    },
    [3]: {
      spacingBottom: "$space$3",
    },
    [4]: {
      spacingBottom: "$space$4",
    },
    [5]: {
      spacingBottom: "$space$5",
    },
    [6]: {
      spacingBottom: "$space$6",
    },
    [7]: {
      spacingBottom: "$space$7",
    },
    [8]: {
      spacingBottom: "$space$8",
    },
    [9]: {
      spacingBottom: "$space$9",
    },
    [10]: {
      spacingBottom: "$space$10",
    },
    [11]: {
      spacingBottom: "$space$11",
    },
    [12]: {
      spacingBottom: "$space$12",
    },
  },
  spacingLeft: {
    [0]: {
      spacingLeft: "0",
    },
    [1]: {
      spacingLeft: "$space$1",
    },
    [2]: {
      spacingLeft: "$space$2",
    },
    [3]: {
      spacingLeft: "$space$3",
    },
    [4]: {
      spacingLeft: "$space$4",
    },
    [5]: {
      spacingLeft: "$space$5",
    },
    [6]: {
      spacingLeft: "$space$6",
    },
    [7]: {
      spacingLeft: "$space$7",
    },
    [8]: {
      spacingLeft: "$space$8",
    },
    [9]: {
      spacingLeft: "$space$9",
    },
    [10]: {
      spacingLeft: "$space$10",
    },
    [11]: {
      spacingLeft: "$space$11",
    },
    [12]: {
      spacingLeft: "$space$12",
    },
  },
};
